import React from 'react';
import { cn } from '../../lib/utils';

// Modern Christmas Garland
export const ChristmasGarland = ({ className }) => {
  const lights = Array.from({ length: 20 }, (_, i) => i);
  const colors = ['#ff0000', '#00ff00', '#0000ff', '#ffff00', '#ff00ff', '#00ffff'];
  
  return (
    <div className={cn("absolute left-0 right-0 h-8 overflow-hidden pointer-events-none", className)}>
      {/* Garland string */}
      <svg viewBox="0 0 1920 32" className="w-full h-full" preserveAspectRatio="none">
        <path
          d="M0 16 Q 48 8, 96 16 T 192 16 T 288 16 T 384 16 T 480 16 T 576 16 T 672 16 T 768 16 T 864 16 T 960 16 T 1056 16 T 1152 16 T 1248 16 T 1344 16 T 1440 16 T 1536 16 T 1632 16 T 1728 16 T 1824 16 T 1920 16"
          fill="none"
          stroke="#15803d"
          strokeWidth="3"
          className="garland-string"
        />
      </svg>
      
      {/* Lights */}
      <div className="absolute inset-0 flex justify-between px-8">
        {lights.map((i) => (
          <div
            key={i}
            className="relative"
            style={{ animationDelay: `${i * 0.1}s` }}
          >
            <div
              className="w-3 h-4 rounded-b-full christmas-light"
              style={{
                backgroundColor: colors[i % colors.length],
                boxShadow: `0 0 8px ${colors[i % colors.length]}, 0 0 12px ${colors[i % colors.length]}`,
                animationDelay: `${i * 0.15}s`
              }}
            />
          </div>
        ))}
      </div>
    </div>
  );
};

// Floating Snowflakes
export const Snowflakes = ({ count = 30, className }) => {
  const snowflakes = Array.from({ length: count }, (_, i) => ({
    id: i,
    left: `${Math.random() * 100}%`,
    animationDuration: `${5 + Math.random() * 10}s`,
    animationDelay: `${Math.random() * 5}s`,
    size: 8 + Math.random() * 12,
    opacity: 0.3 + Math.random() * 0.5
  }));

  return (
    <div className={cn("absolute inset-0 overflow-hidden pointer-events-none", className)}>
      {snowflakes.map((flake) => (
        <div
          key={flake.id}
          className="absolute snowflake"
          style={{
            left: flake.left,
            animationDuration: flake.animationDuration,
            animationDelay: flake.animationDelay
          }}
        >
          <svg
            width={flake.size}
            height={flake.size}
            viewBox="0 0 24 24"
            fill="none"
            style={{ opacity: flake.opacity }}
          >
            <path
              d="M12 2v20M2 12h20M4.93 4.93l14.14 14.14M19.07 4.93L4.93 19.07"
              stroke="#e0f2fe"
              strokeWidth="2"
              strokeLinecap="round"
            />
            <circle cx="12" cy="12" r="2" fill="#e0f2fe" />
          </svg>
        </div>
      ))}
    </div>
  );
};

// Halloween Bats
export const HalloweenBats = ({ count = 8, className }) => {
  const bats = Array.from({ length: count }, (_, i) => ({
    id: i,
    left: `${Math.random() * 100}%`,
    top: `${Math.random() * 60}%`,
    animationDuration: `${3 + Math.random() * 4}s`,
    animationDelay: `${Math.random() * 3}s`,
    size: 20 + Math.random() * 15
  }));

  return (
    <div className={cn("absolute inset-0 overflow-hidden pointer-events-none", className)}>
      {bats.map((bat) => (
        <div
          key={bat.id}
          className="absolute halloween-bat"
          style={{
            left: bat.left,
            top: bat.top,
            animationDuration: bat.animationDuration,
            animationDelay: bat.animationDelay
          }}
        >
          <svg
            width={bat.size}
            height={bat.size * 0.6}
            viewBox="0 0 48 28"
            fill="none"
          >
            <path
              d="M24 8c-4 0-7 2-8 5-3-3-8-5-14-3 4 2 7 5 8 9 0 0 3 4 6 5 2 1 5 2 8 2s6-1 8-2c3-1 6-5 6-5 1-4 4-7 8-9-6-2-11 0-14 3-1-3-4-5-8-5z"
              fill="#1a1a2e"
              className="bat-wing"
            />
            <circle cx="20" cy="12" r="1.5" fill="#ff4444" />
            <circle cx="28" cy="12" r="1.5" fill="#ff4444" />
          </svg>
        </div>
      ))}
    </div>
  );
};

// Halloween Pumpkins floating
export const FloatingPumpkins = ({ count = 5, className }) => {
  const pumpkins = Array.from({ length: count }, (_, i) => ({
    id: i,
    left: `${10 + (i * 20)}%`,
    animationDuration: `${4 + Math.random() * 3}s`,
    animationDelay: `${Math.random() * 2}s`,
    size: 24 + Math.random() * 16
  }));

  return (
    <div className={cn("absolute inset-0 overflow-hidden pointer-events-none", className)}>
      {pumpkins.map((pumpkin) => (
        <div
          key={pumpkin.id}
          className="absolute halloween-float"
          style={{
            left: pumpkin.left,
            bottom: '10px',
            animationDuration: pumpkin.animationDuration,
            animationDelay: pumpkin.animationDelay
          }}
        >
          <svg
            width={pumpkin.size}
            height={pumpkin.size}
            viewBox="0 0 32 32"
            fill="none"
          >
            <ellipse cx="16" cy="18" rx="12" ry="10" fill="#f97316" />
            <path d="M14 8c0-2 1-4 2-4s2 2 2 4" stroke="#15803d" strokeWidth="2" />
            <path d="M10 16l2 2-2 2" stroke="#1a1a2e" strokeWidth="1.5" strokeLinecap="round" />
            <path d="M22 16l-2 2 2 2" stroke="#1a1a2e" strokeWidth="1.5" strokeLinecap="round" />
            <path d="M12 22c2 1 6 1 8 0" stroke="#1a1a2e" strokeWidth="1.5" strokeLinecap="round" />
          </svg>
        </div>
      ))}
    </div>
  );
};

// Summer Beach Waves
export const SummerWaves = ({ className }) => {
  return (
    <div className={cn("absolute bottom-0 left-0 right-0 h-12 overflow-hidden pointer-events-none", className)}>
      <svg viewBox="0 0 1920 48" className="w-full h-full" preserveAspectRatio="none">
        <path
          d="M0 32 Q 120 16, 240 32 T 480 32 T 720 32 T 960 32 T 1200 32 T 1440 32 T 1680 32 T 1920 32 V 48 H 0 Z"
          fill="#0ea5e9"
          opacity="0.3"
          className="summer-wave wave-1"
        />
        <path
          d="M0 36 Q 96 24, 192 36 T 384 36 T 576 36 T 768 36 T 960 36 T 1152 36 T 1344 36 T 1536 36 T 1728 36 T 1920 36 V 48 H 0 Z"
          fill="#06b6d4"
          opacity="0.4"
          className="summer-wave wave-2"
        />
      </svg>
    </div>
  );
};

// Easter Eggs
export const EasterEggs = ({ count = 6, className }) => {
  const eggColors = [
    ['#fbbf24', '#f59e0b'],
    ['#f472b6', '#ec4899'],
    ['#60a5fa', '#3b82f6'],
    ['#4ade80', '#22c55e'],
    ['#c084fc', '#a855f7'],
    ['#fb923c', '#f97316']
  ];
  
  const eggs = Array.from({ length: count }, (_, i) => ({
    id: i,
    left: `${5 + (i * 16)}%`,
    colors: eggColors[i % eggColors.length],
    animationDelay: `${i * 0.3}s`
  }));

  return (
    <div className={cn("absolute inset-0 overflow-hidden pointer-events-none", className)}>
      {eggs.map((egg) => (
        <div
          key={egg.id}
          className="absolute easter-egg"
          style={{
            left: egg.left,
            bottom: '5px',
            animationDelay: egg.animationDelay
          }}
        >
          <svg width="20" height="28" viewBox="0 0 20 28" fill="none">
            <ellipse cx="10" cy="16" rx="8" ry="11" fill={egg.colors[0]} />
            <path d="M4 14c4 1 8 1 12 0" stroke={egg.colors[1]} strokeWidth="2" />
            <path d="M3 18c5 2 9 2 14 0" stroke={egg.colors[1]} strokeWidth="2" />
            <circle cx="7" cy="10" r="1.5" fill="white" opacity="0.6" />
          </svg>
        </div>
      ))}
    </div>
  );
};

// Modern Avatar Decorations (SVG-based)
export const AvatarDecoration = ({ type, className }) => {
  const decorations = {
    christmas: (
      <svg viewBox="0 0 24 24" className={cn("w-6 h-6", className)} fill="none">
        <path d="M12 2l2 6h6l-5 4 2 6-5-4-5 4 2-6-5-4h6z" fill="#fbbf24" stroke="#f59e0b" strokeWidth="0.5" />
      </svg>
    ),
    christmas_hat: (
      <svg viewBox="0 0 32 32" className={cn("w-8 h-8", className)} fill="none">
        <path d="M6 28c0-4 4-12 10-20 6 8 10 16 10 20" fill="#dc2626" />
        <ellipse cx="16" cy="28" rx="12" ry="3" fill="#f1f5f9" />
        <circle cx="16" cy="6" r="3" fill="#f1f5f9" />
      </svg>
    ),
    halloween: (
      <svg viewBox="0 0 24 24" className={cn("w-6 h-6", className)} fill="none">
        <path d="M12 2c-5 0-10 5-10 11 0 4 2 7 5 8 1 1 3 1 5 1s4 0 5-1c3-1 5-4 5-8 0-6-5-11-10-11z" fill="#f97316" />
        <path d="M8 10v2l2-1zm8 0v2l-2-1z" fill="#1a1a2e" />
        <path d="M8 16c2 2 6 2 8 0" stroke="#1a1a2e" strokeWidth="1.5" fill="none" />
      </svg>
    ),
    summer: (
      <svg viewBox="0 0 24 24" className={cn("w-6 h-6", className)} fill="none">
        <circle cx="12" cy="12" r="5" fill="#fbbf24" />
        {[0, 45, 90, 135, 180, 225, 270, 315].map((angle, i) => (
          <line
            key={i}
            x1="12"
            y1="12"
            x2={12 + Math.cos(angle * Math.PI / 180) * 10}
            y2={12 + Math.sin(angle * Math.PI / 180) * 10}
            stroke="#fbbf24"
            strokeWidth="2"
            strokeLinecap="round"
          />
        ))}
      </svg>
    ),
    easter: (
      <svg viewBox="0 0 24 24" className={cn("w-6 h-6", className)} fill="none">
        <ellipse cx="12" cy="14" rx="6" ry="8" fill="#fbbf24" />
        <path d="M7 12h10" stroke="#f59e0b" strokeWidth="1.5" />
        <path d="M6 16h12" stroke="#f59e0b" strokeWidth="1.5" />
      </svg>
    )
  };

  return decorations[type] || null;
};

export default {
  ChristmasGarland,
  Snowflakes,
  HalloweenBats,
  FloatingPumpkins,
  SummerWaves,
  EasterEggs,
  AvatarDecoration
};
